
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Coproratecabandbusserviceisatara() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Service in Satara',
        heading: 'etravo :  Corporate Cab and Bus Service in Satara',
        headingDescription: 'eTravo offers efficient and professional Corporate Cab and Bus Services in Satara, designed to meet the transportation demands of modern businesses. From premium cabs for executives and client visits to well-equipped buses for employee transport and corporate events, we ensure timely, comfortable, and safe travel. Our fleet is maintained to the highest standards, with trained drivers and GPS-enabled tracking to ensure reliability. Trust eTravo in Satara for corporate mobility solutions that prioritize your team"s productivity and comfort.',

        top: 'Top Places to Visit in Satara with etravo',
"topPlaces": [
    {
      "title": "Kaas Plateau (Kaas Pathar)",
      "description": "A UNESCO World Natural Heritage Site, the Kaas Plateau is renowned for its seasonal wildflower blooms, especially between August and September. This volcanic plateau transforms into a vibrant carpet of over 850 species of flowering plants, attracting nature enthusiasts and photographers alike."
    },
    {
      "title": "Thoseghar Waterfalls",
      "description": "Located approximately 20 km from Satara city, Thoseghar Waterfalls is a series of picturesque cascades, with the tallest plunging from a height of about 500 meters. Surrounded by lush greenery, it's a popular spot for picnics and nature walks, especially during the monsoon season."
    },
    {
      "title": "Ajinkyatara Fort",
      "description": "Perched atop one of Satara's seven hills, Ajinkyatara Fort stands at an elevation of 3,300 feet. Historically significant, it offers panoramic views of the city and houses temples like those dedicated to Lord Hanuman and Lord Shiva. The fort is accessible by a motorable road, making it a favored spot for both history buffs and trekkers."
    },
    {
      "title": "Sajjangad Fort",
      "description": "Meaning 'Fort of Good People,' Sajjangad is the final resting place of the revered saint Samarth Ramdas. Located about 18 km from Satara, the fort is a spiritual hub, attracting devotees who come to pay homage and partake in the daily rituals and free meals offered by the managing trust."
    },
    {
      "title": "Pratapgad Fort",
      "description": "Approximately 24 km from Mahabaleshwar, Pratapgad Fort is historically significant as the site of the 1659 battle between Chhatrapati Shivaji Maharaj and Afzal Khan. The fort, built in 1656, features a statue of Shivaji Maharaj, temples, and offers sweeping views of the surrounding valleys."
    },
    {
      "title": "Vajrai Waterfall",
      "description": "Situated near the village of Bhambavli, Vajrai Waterfall is one of the tallest in India, with a three-tiered drop totaling around 260 meters. The waterfall is fed by the Urmodi River and is especially majestic during the monsoon, making it a must-visit for nature lovers."
    },
    {
      "title": "Koyna Wildlife Sanctuary",
      "description": "Part of the Sahyadri Tiger Reserve, Koyna Wildlife Sanctuary spans over 423 square kilometers. Rich in biodiversity, it is home to species like tigers, leopards, and various birds. The sanctuary also encompasses the Shivsagar Lake, formed by the Koyna Dam, adding to its ecological significance."
    },
    {
      "title": "Shri Uttar Chidambaram Nataraja Mandir",
      "description": "Inspired by the Chidambaram Temple in Tamil Nadu, this temple in Satara is dedicated to Lord Nataraja, the cosmic dancer form of Lord Shiva. The temple's architecture and spiritual ambiance make it a serene spot for devotees and tourists alike."
    },
    {
      "title": "Sangam Mahuli",
      "description": "A sacred confluence of the Krishna and Venna rivers, Sangam Mahuli is a revered pilgrimage site. The area is dotted with ancient temples and is especially vibrant during religious festivals, attracting devotees from various regions."
    },
    {
      "title": "Chandan-Vandan Forts",
      "description": "These twin forts, located near Satara, are popular trekking destinations. Chandan Fort houses ancient temples and a dargah, while Vandan Fort offers panoramic views of the surrounding landscape. Both forts are steeped in history and provide insights into the region's past."
    }
  ],
   "services": [
    {
      "name": "Corporate Employee Transportation in Satara",
      "description": "eTravo offers reliable and customized corporate employee transportation services in Satara. Whether your company requires daily pick-up and drop-off for staff or scheduled shuttle services for multiple shifts, we ensure punctual, safe, and comfortable travel. With a fleet of GPS-enabled vehicles and trained drivers, our transport plans can be tailored to your organization’s size and operational hours, ensuring uninterrupted mobility for your workforce."
    },
    {
      "name": "Rent Buses and Cabs for Business in Satara",
      "description": "Need flexible transport options for your business in Satara? eTravo provides a wide range of buses and cabs for rent to suit every corporate requirement—from executive airport transfers and client visits to large-scale staff movement. Our fleet includes AC cabs, mini-buses, and full-size coaches available on hourly, daily, or long-term contracts. Enjoy clean vehicles, professional service, and real-time coordination tailored to business standards."
    },
    {
      "name": "Staff Pickup & Drop Services in Satara",
      "description": "Ensure your employees reach the workplace safely and on time with eTravo’s staff pickup and drop services in Satara. Designed for companies with fixed or rotational shifts, our services offer efficient scheduling, optimized routing, and 24/7 support. With sanitized vehicles, courteous drivers, and real-time tracking, we provide consistent and worry-free employee transport daily."
    },
    {
      "name": "Office Commute Bus Services Satara",
      "description": "eTravo’s office commute bus services in Satara simplify daily employee travel by offering dedicated, or zonal route buses. These services help reduce absenteeism, improve productivity, and ensure your staff enjoys a smooth and timely commute. Our buses are air-conditioned, regularly serviced, and backed by a strong support system for uninterrupted operations."
    },
    {
      "name": "Budget-Friendly Corporate Transport Satara",
      "description": "Looking for cost-effective transportation options for your business in Satara? eTravo provides budget-friendly corporate transport solutions that balance affordability with reliability. Ideal for startups and growing companies, our mobility options, route bundling, and flexible rental packages help optimize your transport budget without sacrificing comfort or efficiency."
    },
    {
      "name": "Corporate Shuttle Bus Hire Satara",
      "description": "eTravo offers corporate shuttle bus hire services in Satara that are perfect for inter-office transfers, daily routes, and staff movement across industrial zones. These shuttle services can be customized to cover key employee locations and operational time slots. Our modern shuttle fleet includes AC mini-buses and coaches equipped with tracking systems to ensure smooth and on-time travel."
    },
    {
      "name": "Business Travel Cab Rentals in Satara",
      "description": "For executive and client-facing travel needs, eTravo’s business travel cab rentals in Satara deliver comfort, style, and professionalism. We offer well-maintained AC cabs with trained chauffeurs for meetings, airport transfers, site visits, and other official travel. Choose from our range of sedans, SUVs, and premium cars with easy booking and flexible billing options to meet your business travel expectations."
    }
  ],
  "tableData": [
    ["Corporate Employee Transportation in Satara", "Rent Buses and Cabs for Business in Satara"],
    ["Staff Pickup & Drop Services in Satara", "Office Commute Bus Services Satara"],
    ["Budget-Friendly Corporate Transport Satara", "Corporate Shuttle Bus Hire Satara"],
    ["Business Travel Cab Rentals in Satara", ""]
  ],







"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Corporate Transportation",
        "WhyChoosedescription": "At eTravo, we understand that time is crucial in the corporate world. Our corporate cab and bus service in Satara is known for punctuality and reliability. Whether it’s a daily employee commute or transportation for business meetings and events, we ensure that your team arrives on time, every time, without any delays or disruptions."
    },
    {
        "WhyChooseheading": "Comfortable and Versatile Fleet of Vehicles",
        "WhyChoosedescription": "eTravo offers a wide range of vehicles to suit all your corporate travel needs in Satara. From premium air-conditioned cabs for executives to large, comfortable buses for group transport, each vehicle is well-maintained, clean, and equipped with modern amenities to provide a smooth and relaxing travel experience."
    },
    {
        "WhyChooseheading": "Trained, Courteous, and Professional Drivers",
        "WhyChoosedescription": "Our drivers are more than just chauffeurs—they are trained professionals who understand the expectations of corporate clients. With deep knowledge of Satara’s routes, traffic patterns, and safety protocols, they ensure a smooth and secure ride while maintaining professionalism, politeness, and punctuality throughout the journey."
    },
    {
        "WhyChooseheading": "Upfront Pricing with No Hidden Charges",
        "WhyChoosedescription": "Transparency is at the heart of our service. With eTravo, you receive a clear and honest pricing structure for your corporate cab and bus services in Satara. There are no last-minute surprises or hidden fees—just straightforward rates that allow your company to plan and budget effectively."
    },
    {
        "WhyChooseheading": "Uncompromising Focus on Safety and Cleanliness",
        "WhyChoosedescription": "Your team’s safety and comfort are our top priorities. All our vehicles are equipped with GPS tracking, emergency safety kits, seat belts, and are sanitized regularly. We conduct routine maintenance and safety checks to ensure every ride is secure, hygienic, and dependable for your employees and guests."
    },
    {
        "WhyChooseheading": "24/7 Operational Support and Flexible Scheduling",
        "WhyChoosedescription": "eTravo is always on call to support your corporate travel requirements in Satara. Whether it’s early morning pickups, late-night drop-offs, or sudden changes to your travel schedule, our dedicated team is available around the clock to accommodate your business’s dynamic needs."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Real-Time Management",
        "WhyChoosedescription": "Managing transportation has never been easier. With our intuitive online booking platform, you can schedule, modify, and track your corporate cab and bus bookings in Satara in real-time. Our customer service team is also just a call away to assist with custom arrangements or support."
    },
    {
        "WhyChooseheading": "Tailored Transport Solutions for Every Business Scenario",
        "WhyChoosedescription": "At eTravo, we recognize that no two businesses are alike. That’s why we offer customized corporate travel packages in Satara—whether you need recurring employee shuttle services, transportation for off-site meetings, or event-specific travel solutions. We work closely with your team to design services that align with your company’s unique needs and goals."
    }
]





















    }


   



// Corporate Cab and Bus Service in Satara – eTravo

const faqData = [
    [
        {
            question: 'What services does eTravo offer for corporate cab and bus transport in Satara?',
            answer: 'eTravo offers end-to-end corporate transportation in Satara, including employee cab services, staff shuttle buses, VIP transfers, and corporate event logistics — all customized to suit business needs.',
        },
        {
            question: 'Can eTravo handle regular employee commutes for our company in Satara?',
            answer: 'Yes, we specialize in daily transportation solutions with fixed routes and schedules using both cabs and buses. Services are tailored to match your shift patterns and office hours.',
        },
        {
            question: 'What types of vehicles are available for corporate clients in Satara?',
            answer: 'Our fleet includes well-maintained sedans, SUVs, and executive cabs for senior staff, along with AC buses and mini-buses for group employee transport — all optimized for comfort and reliability.',
        },
        {
            question: 'Does eTravo offer safety features and monitoring tools for corporate clients?',
            answer: 'Absolutely. We use GPS-enabled vehicles, live tracking systems, and provide trip reports to ensure transparency, safety, and real-time monitoring of your corporate transportation.',
        },
        {
            question: 'Can we book transportation for corporate events, visits, or conferences in Satara?',
            answer: 'Yes, eTravo offers flexible transport arrangements for corporate events, client visits, site tours, and group meetings, ensuring timely service and professional coordination.',
        },
        {
            question: 'Is there dedicated support for managing our corporate transport in Satara?',
            answer: 'Yes, each corporate account is assigned a dedicated manager who coordinates bookings, routes, reporting, and support to ensure a seamless experience.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Vaibhav Naik',
        designation: 'Admin Head, ProLink Systems',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has simplified employee transportation for our Satara office. Their buses are always punctual, clean, and the drivers are well-trained. Excellent support and service.”',
    },
    {
        name: 'Ms. Swati Kharat',
        designation: 'HR Manager, NexPhase Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve used eTravo for both daily commutes and corporate events in Satara. Their coordination is smooth and the service is reliable. Highly recommend for corporate transport needs.”',
    },
];





















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Service in Satara",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-satara.jpg",
  "description": "Reliable and affordable corporate cab and bus services in Satara by eTravo. Ideal for employee transportation, staff pickup & drop, office commute, and business travel with AC vehicles and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3712"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-service-in-satara"
  }
};





    return (
        <div>
<Helmet>
  <title>Corporate Cab and Bus Service in Satara | Employee Transport & Shuttle | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus service in Satara with eTravo for employee transportation, office commutes, and business travel. Budget-friendly, reliable, and AC vehicles available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/6.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Coproratecabandbusserviceisatara;